import { getHeaderActiveColumns, TD } from "../../../../../util/table";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import IngenRegistreringer from "../IngenRegistreringer";
import OpretNyButtonBlock from "../OpretNyButtonBlock";
import { defaultPersonInteresseColumns } from "../../../../../config/person";
import { personInteresseForm } from "../../../../../config/form/person/personInteresseFormConfig";
import { useGenericQuery } from "../../../../../hooks/useQueries";
import ButtonDownload from "../../../../ButtonDownload";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import { PersonDto } from "../../../../../interfaces/schema";
import { PersonInteresseField } from "../../../../../interfaces/personer";
import { IColumn, SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { orderBy } from "../../../../../util/orderBy";

export default function InteresseOmraader({
  invalidateData,
  person,
  personInteresseColumns,
  setPersonInteresseActiveColumns,
}: {
  person: PersonDto;
  personInteresseColumns: IColumn<PersonInteresseField>[];
  setPersonInteresseActiveColumns: React.Dispatch<
    React.SetStateAction<PersonInteresseField[]>
  >;
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const isAuth = hasPermission(user, "BasisWrite");
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personInteresseOmraaderSortBy_2",
    {
      defaultValue: defaultSortBy,
    },
  );
  const { personInteresse } = person;
  const queryValues = useGenericQuery<IInteresse>("interesser");

  if (!personInteresse || personInteresse.length === 0) {
    return (
      <>
        <IngenRegistreringer
          editConfig={
            isAuth ? personInteresseForm(queryValues, person.id) : undefined
          }
          invalidateData={invalidateData}
        />
      </>
    );
  }

  return (
    <>
      <ButtonDownload
        onClick={() =>
          tableToXLSX(personInteresseColumns, personInteresse, {
            fileName: `interesseområder-for-${person.kundeNr}`,
            additionalData: {
              kundenr: person.kundeNr,
            },
          })
        }
      />
      <TableBasic
        defaultColumns={defaultPersonInteresseColumns}
        columns={personInteresseColumns}
        setActiveColumns={setPersonInteresseActiveColumns}
        headerRow={
          <>
            {getHeaderActiveColumns(personInteresseColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        }
      >
        {orderBy(
          personInteresse,
          sortBy.map((s) => s.field),
          sortBy.map((s) => s.direction),
        ).map((interesse) => {
          const { id, interesseId } = interesse;
          return (
            <TableRow
              key={id}
              editConfig={
                isAuth
                  ? personInteresseForm(queryValues, person.id, {
                      id,
                      interesseId,
                    })
                  : undefined
              }
              invalidateData={invalidateData}
            >
              <>
                {personInteresseColumns
                  .filter((col) => col.active)
                  .map((col) => (
                    <TD key={col.field} col={col} rowData={interesse} />
                  ))}
              </>
            </TableRow>
          );
        })}
      </TableBasic>
      {personInteresse.length >= 3 ? (
        <OpretNyButtonBlock disabled />
      ) : (
        <OpretNyButtonBlock
          editConfig={
            isAuth ? personInteresseForm(queryValues, person.id) : undefined
          }
          invalidateData={invalidateData}
        />
      )}
    </>
  );
}

const defaultSortBy: SortBy<PersonInteresseField>[] = [
  {
    direction: "asc",
    field: "interesse.forkortelse",
  },
];
